import "vuetify/styles";
import { createVuetify } from "vuetify";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "@mdi/font/css/materialdesignicons.css";

// Professional color theme - matching admin portal black theme
const lightTheme = {
  dark: false,
  colors: {
    primary: "#000000",
    "primary-darken-1": "#1a1a1a",
    "primary-lighten-1": "#333333",
    secondary: "#2196F3",
    "secondary-darken-1": "#1976D2",
    "secondary-lighten-1": "#42A5F5",
    accent: "#FF9800",
    error: "#f44336",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FF9800",
    background: "#FAFAFA",
    surface: "#FFFFFF",
    "on-primary": "#FFFFFF",
    "on-secondary": "#FFFFFF",
    "on-surface": "#212121",
    "on-background": "#212121",
    "surface-variant": "#F5F5F5",
    "on-surface-variant": "#424242",
  },
};

const darkTheme = {
  dark: true,
  colors: {
    primary: "#11a4d4",
    "primary-darken-1": "#0e85ad",
    "primary-lighten-1": "#38bdf8",
    secondary: "#42A5F5",
    "secondary-darken-1": "#2196F3",
    "secondary-lighten-1": "#64B5F6",
    accent: "#FFB74D",
    error: "#EF5350",
    info: "#42A5F5",
    success: "#66BB6A",
    warning: "#FFB74D",
    background: "#0c0d10",
    surface: "#16181f",
    "on-primary": "#FFFFFF",
    "on-secondary": "#FFFFFF",
    "on-surface": "#f3f4f6",
    "on-background": "#f3f4f6",
    "surface-variant": "#1e2028",
    "on-surface-variant": "#9ca3af",
  },
};

// Custom defaults for components
const defaults = {
  VBtn: {
    style: "text-transform: none; font-weight: 600;",
  },
  VCard: {
    elevation: 2,
    rounded: "lg",
  },
  VSheet: {
    rounded: "lg",
  },
  VTextField: {
    variant: "outlined" as const,
    density: "comfortable" as const,
    hideDetails: "auto" as const,
  },
  VSelect: {
    variant: "outlined" as const,
    density: "comfortable" as const,
    hideDetails: "auto" as const,
  },
  VTextarea: {
    variant: "outlined" as const,
    density: "comfortable" as const,
    hideDetails: "auto" as const,
  },
  VChip: {
    rounded: "pill" as const,
  },
  VAlert: {
    rounded: "lg" as const,
    variant: "tonal" as const,
  },
  VDialog: {
    maxWidth: "600px",
  },
  VExpansionPanels: {
    variant: "accordion" as const,
    rounded: "lg" as const,
  },
};

export default createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
    variations: {
      colors: ["primary", "secondary", "accent", "success", "warning", "error"],
      lighten: 5,
      darken: 5,
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
  defaults,
  display: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1264,
      xl: 1904,
    },
  },
});
